// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : COMMENT LINES ADDED
// MODFIED DATA : 01-08-2025

import { put, takeLatest, call, all } from 'redux-saga/effects';
import {
	addDealerDetailsFailure,
	addDealerDetailsSuccess,
	addDealerDetailsResponseChanged,
	updateDealerDetailsFailure,
	updateDealerDetailsSuccess,
	updateDealerDetailsResponseChanged,
	getDealerListFailure,
	getDealerListResponseChanged,
	getDealerListSuccess,
	fetchDealerDetailsFailure,
	fetchDealerDetailsSuccess,
	fetchDealerDetailsResponseChanged,
	deleteDealerDetailsFailure,
	deleteDealerDetailsSuccess,
	deleteDealerDetailsResponseChanged,
	deleteDealerStaffDetailsFailure,
	deleteDealerStaffDetailsSuccess,
	deleteDealerStaffDetailsResponseChanged,
	approveDealerDetailsFailure,
	approveDealerDetailsSuccess,
	approveDealerDetailsResponseChanged,
} from './dealer.action';
import DealerActionTypes from './dealer.types';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	dealerDetailsAdd,
	dealerDetailsDelete,
	dealerDetailsFetch,
	dealerDetailsUpdate,
	dealerListGet,
	dealerStaffDetailsDelete,
	dealerApprove,
} from './dealer.services';

/** ***************** ADD DEALER DETAILS START *********************** */
export function* addDealerDetails({ payload }: any) {
	try {
		const key = 'AddDealerKey';
		const StaffArray = JSON.stringify(
			payload.staff && payload.staff.length > 0 ? payload.staff : [],
		).replace(/"/g, "'");
		const {
			country,
			pincode,
			village,
			state,
			district,
			postOffice,
			dealerGstNo,
			dealerPhoneNumber,
			dealerName,
			bankAccountNumber,
			bankPassbook,
			accountHolderName,
			ifscCode,
			bankName,
			branchName,
			companyID,
			userID,
			userName,
			userAccessBranchID,
			databaseName,
			userRole,
			userLevel,
			ownerAlterNativeNo,
			ownerName,
			branchID,
		} = payload;
		const jsonData = {
			Country: country,
			Pincode: pincode,
			Village: village,
			State: state,
			District: district,
			PostOffice: postOffice,
			DealerGstNo: dealerGstNo,
			DealerPhoneNumber: dealerPhoneNumber,
			DealerName: dealerName,
			BankAccountNumber: bankAccountNumber,
			BankPassbook: bankPassbook,
			AccountHolderName: accountHolderName,
			IfscCode: ifscCode,
			BankName: bankName,
			BranchName: branchName,
			CompanyID: companyID,
			CreatedBy: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			DatabaseName: databaseName,
			UserRole: userRole,
			UserLevel: userLevel,
			StaffArray,
			OwnerAlterNativeNo: ownerAlterNativeNo,
			OwnerName: ownerName,
			BranchID: branchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dealerDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addDealerDetailsFailure(responseData.data));
		} else {
			yield put(addDealerDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addDealerDetailsFailure(error));
	}
}

export function* resetAddDealerResponse() {
	yield put(addDealerDetailsResponseChanged());
}

export function* onAddDealerDetails() {
	yield takeLatest(DealerActionTypes.ADD_DEALER_DETAILS_START, addDealerDetails);
}

export function* onAddDealerDetailsResponseReset() {
	yield takeLatest(DealerActionTypes.ADD_DEALER_DETAILS_RESPONSE_RESET, resetAddDealerResponse);
}
/** ***************** ADD DEALER DETAILS END *********************** */

/** *********************  START UPDATE DEALER DETAILS  ******************** */
export function* updateDealerDetails({ payload }: any) {
	try {
		const key = 'UpdateDealerKey';
		const StaffArray = JSON.stringify(
			payload.staff && payload.staff.length > 0 ? payload.staff : [],
		).replace(/"/g, "'");
		const {
			dealerID,
			country,
			pincode,
			village,
			state,
			district,
			postOffice,
			dealerGstNo,
			dealerPhoneNumber,
			dealerName,
			bankAccountNumber,
			bankPassbook,
			accountHolderName,
			ifscCode,
			bankName,
			branchName,
			companyID,
			userID,
			userName,
			userAccessBranchID,
			databaseName,
			userRole,
			userLevel,
			ownerAlterNativeNo,
			ownerName,
			branchID,
		} = payload;
		const jsonData = {
			DealerID: dealerID,
			Country: country,
			Pincode: pincode,
			Village: village,
			State: state,
			District: district,
			PostOffice: postOffice,
			DealerGstNo: dealerGstNo,
			DealerPhoneNumber: dealerPhoneNumber,
			DealerName: dealerName,
			BankAccountNumber: bankAccountNumber,
			BankPassbook: bankPassbook,
			AccountHolderName: accountHolderName,
			IfscCode: ifscCode,
			BankName: bankName,
			BranchName: branchName,
			CompanyID: companyID,
			CreatedBy: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			DatabaseName: databaseName,
			UserRole: userRole,
			UserLevel: userLevel,
			StaffArray,
			OwnerAlterNativeNo: ownerAlterNativeNo,
			OwnerName: ownerName,
			BranchID: branchID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dealerDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateDealerDetailsFailure(responseData.data));
		} else {
			yield put(updateDealerDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateDealerDetailsFailure(error));
	}
}

export function* resetUpdateDealerDetailsResponse() {
	yield put(updateDealerDetailsResponseChanged());
}

export function* onUpdateDealerDetails() {
	yield takeLatest(DealerActionTypes.UPDATE_DEALER_DETAILS_START, updateDealerDetails);
}

export function* onUpdateDealerResponseReset() {
	yield takeLatest(
		DealerActionTypes.UPDATE_DEALER_DETAILS_RESPONSE_RESET,
		resetUpdateDealerDetailsResponse,
	);
}
/** *********************  END UPDATE DEALER DETAILS ******************** */

/** *********************  START GET DEALER LIST  ******************** */
export function* getAllDealerList({ payload }: any) {
	try {
		const key = 'FetchDealerListKey';
		const {
			companyID,
			userID,
			userRole,
			userLevel,
			databaseName,
			userAccessBranchID,
			inputSearch,
			limit,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			DatabaseName: databaseName,
			BranchID: userAccessBranchID,
			InputSearch: inputSearch,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dealerListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDealerListFailure(responseData.data));
		} else {
			yield put(getDealerListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDealerListFailure(error));
	}
}

export function* resetGetBranchListResponse() {
	yield put(getDealerListResponseChanged());
}

export function* onGetBranchListDetails() {
	yield takeLatest(DealerActionTypes.GET_DEALER_LIST_START, getAllDealerList);
}

export function* onGetBranchListResponseReset() {
	yield takeLatest(DealerActionTypes.GET_DEALER_LIST_RESPONSE_RESET, resetGetBranchListResponse);
}
/** *********************  END GET DEALER LIST ******************** */

/** *********************  START FETCH DEALER DETAILS  ******************** */
export function* fetchDealerDetails({ payload }: any) {
	try {
		const key = 'GetParticularDealerKey';
		const { dealerID, companyID, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			DealerID: dealerID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dealerDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchDealerDetailsFailure(responseData.data));
		} else {
			yield put(fetchDealerDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchDealerDetailsFailure(error));
	}
}

export function* resetFetchDealerDetailsResponse() {
	yield put(fetchDealerDetailsResponseChanged());
}

export function* onFetchDealerDetails() {
	yield takeLatest(DealerActionTypes.FETCH_DEALER_DETAILS_START, fetchDealerDetails);
}

export function* onFetchDealerDetailsResponseReset() {
	yield takeLatest(
		DealerActionTypes.FETCH_DEALER_DETAILS_RESPONSE_RESET,
		resetFetchDealerDetailsResponse,
	);
}
/** *********************  END FETCH DEALER DETAILS ******************** */

/** *********************  START DELETE DEALER DETAILS  ******************** */
export function* deleteDealer({ payload }: any) {
	try {
		const key = 'DeleteDealerDetailKey';
		const { dealerID, companyID, userID, userName, userAccessBranchID, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			DealerID: dealerID,
			DatabaseName: databaseName,
			DeletedBy: userID,
			UserAccessBranchID: userAccessBranchID,
			UserName: userName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dealerDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteDealerDetailsFailure(responseData.data));
		} else {
			yield put(deleteDealerDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteDealerDetailsFailure(error));
	}
}

export function* resetDealerBranchDetailsResponse() {
	yield put(deleteDealerDetailsResponseChanged());
}

export function* onDealerBranchDetails() {
	yield takeLatest(DealerActionTypes.DELETE_DEALER_DETAILS_START, deleteDealer);
}

export function* onDeleteDealerDetailsResponseReset() {
	yield takeLatest(
		DealerActionTypes.DELETE_DEALER_DETAILS_RESPONSE_RESET,
		resetDealerBranchDetailsResponse,
	);
}
/** *********************  END DELETE DEALER DETAILS ******************** */

/** *********************  START DELETE DEALER STAFF DETAILS  ******************** */

export function* deleteDealerStaffDetails({ payload }: any) {
	try {
		const key = 'DeleteDealerStaffDetailKey';
		const { dealerID, staffID, companyID, userID, userName, userAccessBranchID, databaseName } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			DealerID: dealerID,
			StaffID: staffID,
			DatabaseName: databaseName,
			DeletedBy: userID,
			UserAccessBranchID: userAccessBranchID,
			UserName: userName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dealerStaffDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteDealerStaffDetailsFailure(responseData.data));
		} else {
			yield put(deleteDealerStaffDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteDealerStaffDetailsFailure(error));
	}
}

export function* resetDealerStaffDetailsResponse() {
	yield put(deleteDealerStaffDetailsResponseChanged());
}

export function* onDeleteDealerStaffDetails() {
	yield takeLatest(DealerActionTypes.DELETE_DEALER_STAFF_DETAILS_START, deleteDealerStaffDetails);
}

export function* onDeleteDealerStaffDetailsResponseReset() {
	yield takeLatest(
		DealerActionTypes.DELETE_DEALER_STAFF_DETAILS_RESPONSE_RESET,
		resetDealerStaffDetailsResponse,
	);
}
/** *********************  END DELETE DEALER STAFF DETAILS ******************** */

/** *********************  START APPROVE DEALER  ******************** */
export function* approveDealerDetails({ payload }: any) {
	try {
		const key = 'ApproveDealerKey';
		const { dealerID, approvalStatus, companyID, userID, userName, databaseName } = payload;
		const jsonData = {
			DealerID: dealerID,
			ApprovalStatus: approvalStatus,
			CompanyID: companyID,
			UserID: userID,
			UserName: userName,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dealerApprove, encodeData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(approveDealerDetailsFailure(responseData.data));
		} else {
			yield put(approveDealerDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(approveDealerDetailsFailure(error));
	}
}

export function* resetApproveDealerDetailsResponse() {
	yield put(approveDealerDetailsResponseChanged());
}

export function* onApproveDealerDetails() {
	yield takeLatest(DealerActionTypes.APPROVE_DEALER_START, approveDealerDetails);
}

export function* onApproveDealerDetailsResponseReset() {
	yield takeLatest(
		DealerActionTypes.APPROVE_DEALER_RESPONSE_RESET,
		resetApproveDealerDetailsResponse,
	);
}
/** *********************  END APPROVE DEALER ******************** */

export function* dealerMasterSaga() {
	yield all([
		call(onAddDealerDetails),
		call(onAddDealerDetailsResponseReset),
		call(onUpdateDealerDetails),
		call(onUpdateDealerResponseReset),
		call(onGetBranchListDetails),
		call(onGetBranchListResponseReset),
		call(onFetchDealerDetails),
		call(onFetchDealerDetailsResponseReset),
		call(onDealerBranchDetails),
		call(onDeleteDealerDetailsResponseReset),
		call(onDeleteDealerStaffDetails),
		call(onDeleteDealerStaffDetailsResponseReset),
		call(onApproveDealerDetails),
		call(onApproveDealerDetailsResponseReset),
	]);
}
